/*
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import env from '../env';
import moment from 'moment';

const Globals = {
	debugMode: false,
	// baseURL: __DEV__ ? 'http://' + env.ip + '/WscInMe/' : 'https://wscinme.com/',
	// mediaBaseURL: __DEV__ ? 'http://' + env.ip + '/WscInMe/Songs/download/' : 'https://wscinme.com/Songs/download/',
	// baseURL: 'http://' + env.ip + '/WscInMe/',
	// mediaBaseURL: 'http://' + env.ip + '/WscInMe/Songs/download/',
	baseURL: 'https://wscinme.com/',
	mediaBaseURL: 'https://wscinme.com/Songs/download/',
	pulseInterval: 250,
	clearAsync: false,
	clearSecure: false,
	clearEvents: false,
	clearAllFiles: false,
	clearBrowserCache: false,
	clearDataBefore: moment('2022-04-31 00:00:00'),


	user: null,
	audioPlayer: null,
};

export default Globals;